// extracted by mini-css-extract-plugin
export var copyButton = "copy-button_ECaQC2dNIcPdDrHvHXED";